import { atom } from 'recoil';
import { INSTANCE_BASED_CLUSTER } from 'pages/provisioning/aws/document-db/constant';

export const toggleSspModels = atom({
    key: 'document-db-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDatabaseNameModalOpen: false,
    },
});

export const isEnvDetailsLoading = atom({
    key: 'document-db-isEnvDetailsLoading',
    default: false,
});

export const orderId = atom({
    key: 'document-db-orderId',
    default: '',
});

export const isExpectedDbSizeValidApiLoading = atom({
    key: 'document-db-isExpectedDbSizeValidLoading',
    default: false,
});

export const sspSubmitOrder = atom({
    key: 'document-db-sspOrder',
    default: {
        // Application Section
        applicationName: null,
        appShortName: null,
        appProfile: null,
        drPriority: null,
        entityDetails: null,
        sector: null,
        sectorDetails: null,
        department: null,
        appRegion: null,
        environment: null,
        landingZoneDetails: null,
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,

        // Resource Section
        awsAccount: null,
        vpcId: null,
        clusterIdentifier: null,
        shardConfigurations: [],
        databaseName: '',
        isManualDBName: false,
        clusterType: INSTANCE_BASED_CLUSTER,
        enableGlobalCluster: 'no',
        engineVersion: null,
        instanceClass: null,
        numberOfInstances: null,
        expDBSize: null,
        minCapacityDcus: null,
        maxCapacityDcus: null,
        secondaryRegion: null,
        globalClusterIdentifier: null,
        shardCount: null,
        instancesPerShard: null,
        c: null,

        // Application Component Security Group Section
        componentName: null,
        componentNameDetails: null,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
        isDBNameValid: false,
        isExpDBSizeValid: false,
    },
});

export const costEstimateState = atom({
    key: 'document-db-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'document-db-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isValidProvisioningForm = atom({
    key: 'document-db-isValidProvisioningForm',
    default: false,
});

export const isAppNameValid = atom({
    key: 'document-db-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'document-db-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'document-db-isAppShortNameExist',
    default: false,
});
